import React, { useMemo } from "react";
import { DEFAULT_PROJECT_PALETTE, PROJECT_PALETTES } from "@lifeat/shared/projects/ProjectsConstants";
import LifeAtProgressBar from "@common/LifeAtProgressBar/LifeAtProgressBar";
import { useAppearanceContext } from "@contexts/AppearanceContext";
import { blendHexColors } from "@util/StyleUtil";
import { ClientTaskListType } from "../../task-management/TaskManagementTypes";

interface ProjectsTaskProgressBarProps {
    readonly projectColor?: string | null;
    readonly taskList?: ClientTaskListType;
    readonly className?: string;
}
export default function ProjectsTaskProgressBar(props: ProjectsTaskProgressBarProps) {
    const { lightMode } = useAppearanceContext();

    const taskList = props.taskList ? Object.values(props.taskList) : [];

    const totalTaskCount = taskList.length;
    const completedTaskCount = useMemo(() => taskList.filter((task) => task.status === "COMPLETE").length, [taskList]);
    const completionPercentage = (completedTaskCount / totalTaskCount) * 100 || 0;

    const projectColorPalette =
        PROJECT_PALETTES.find((c) => c.primary === props.projectColor) ?? DEFAULT_PROJECT_PALETTE;
    const progressBarBackgroundColor = lightMode
        ? blendHexColors(projectColorPalette.lighter, projectColorPalette.darker, 0.9)
        : blendHexColors(projectColorPalette.darker, projectColorPalette.lighter, 0.9);
    const progressBarFillColor = lightMode
        ? blendHexColors(projectColorPalette.primary, projectColorPalette.darker, 0.8)
        : blendHexColors(projectColorPalette.darker, projectColorPalette.primary, 0.3);

    return (
        <LifeAtProgressBar
            progressPercentage={completionPercentage}
            progressNum={completedTaskCount}
            progressTotal={totalTaskCount}
            overrideBackgroundHex={progressBarBackgroundColor}
            overrideFillHex={progressBarFillColor}
            className={props.className}
        />
    );
}
